import { Button, DatePicker, Form, Input, Select } from 'antd'
import { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

import { debounce } from 'lodash'
import { removeVietnameseTones } from '../../config-func'
import { PRODUCT_TYPE_WEB_FEE, ProductType, getSubProductType } from '../PostManagement/configs'
import { OPTIONS_WEB_FEE } from './configs'
const { RangePicker } = DatePicker
const { Option } = Select

const SearchForm = ({ fetchData, handleSearch, setFilters, postDateOptions }) => {
  const [form] = Form.useForm()
  const [realEstateOptions, setRealEstateOptions] = useState(PRODUCT_TYPE_WEB_FEE)
  const handleReset = debounce(() => {
    form.resetFields()
    setFilters({ currentPage: 1, pageSize: 10, reset: uuidv4() })
  }, 300)

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      style={{ marginTop: 10 }}
      onValuesChange={(changedValues, allValues) => {
        if (Object.prototype.hasOwnProperty.call(changedValues, 'propertyType')) {
          const pt = changedValues.propertyType
          if (pt) {
            const subs = getSubProductType(pt) || []
            setRealEstateOptions(subs)
            form.setFieldsValue({ realEstateType: [] })
          } else {
            setRealEstateOptions(PRODUCT_TYPE_WEB_FEE)
            form.setFieldsValue({ realEstateType: [] })
          }
        }
        setFilters((prev) => ({ ...prev, ...allValues }))
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
          alignItems: 'center'
        }}
      >
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Nhu cầu" name="demand">
            <Select
              style={{ width: '100%' }}
              placeholder="Chọn nhu cầu"
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase();
                const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                return optionValue.includes(inputValue);
              }}
            >
              <Option value="">Tất cả</Option>
              <Option value="sell">Bán</Option>
              <Option value="rent">Thuê</Option>
              <Option value="buying">Tìm mua</Option>
              <Option value="renting">Tìm thuê</Option>
            </Select>
          </Form.Item>
        </div>

        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Loại BĐS" name="propertyType">
            <Select
              style={{ width: '100%' }}
              placeholder="Chọn loại BĐS"
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase();
                const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                return optionValue.includes(inputValue);
              }}
              onChange={(value) => {
                if (value) {
                  const subs = getSubProductType(value) || []
                  setRealEstateOptions(subs)
                  form.setFieldsValue({ realEstateType: [] })
                } else {
                  setRealEstateOptions(PRODUCT_TYPE_WEB_FEE)
                  form.setFieldsValue({ realEstateType: [] })
                }
              }}
            >
              <Option value="">Tất cả</Option>
              {ProductType.map((item) => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div style={{ flex: '1 1 240px', minWidth: '240px' }}>
          <Form.Item label="Loại hình BĐS" name="realEstateType">
            <Select
              // mode="multiple"
              style={{ width: '100%' }}
              placeholder="Chọn loại hình BĐS"
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase();
                const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                return optionValue.includes(inputValue);
              }}
            >
              {realEstateOptions.map((item) => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Thời gian" name="timeEx">
           <Select style={{ width: '100%' }} placeholder="Chọn thời gian">
                {postDateOptions?.map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.title}
                  </Option>
                ))}
              </Select>
          </Form.Item>
        </div>

        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Loại thu phí" name="type">
            <Select
              style={{ width: '100%' }}
              placeholder="Chọn loại"
              defaultValue="Tất cả"
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase();
                const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                return optionValue.includes(inputValue);
              }}
            >
              <Option value="">Tất cả</Option>
              {OPTIONS_WEB_FEE.map((item, idx) => (
                <Option key={idx} value={item.value}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Tên gói" name="packageName">
            <Input
              placeholder="Nhập tên"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'packageName',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
        </div>
        <div
          style={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'flex-end',
            flex: '1 1 200px',
            minWidth: '200px'
          }}
        >
          <Button onClick={handleReset}>Đặt lại</Button>
          <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }}>
            Tìm kiếm
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default SearchForm
